import React from "react"
import styled, { injectGlobal } from "styled-components"
import * as PropTypes from "prop-types"

import Summary from "./../components/summary"

const propTypes = {
  data: PropTypes.object.isRequired
}

class FooterPage extends React.Component {
  render() {
    return (
      <div style={{
          backgroundColor: '#fff'
        }}
      >
        <Summary data={this.props.data.allContentfulSummary.edges[0].node} />
      </div>
    )
  }
}

FooterPage.propTypes = propTypes

export default FooterPage

export const footerPageQuery = graphql`
  query FooterPageQuery {
    allContentfulSummary {
      edges {
        node {
          body {
            childMarkdownRemark {
              html
            }
          }
          title
          youTubeId
          youTubePoster {
            responsiveResolution(width: 1400) {
              width
              height
              src
              srcSet
            }
            title
          }
        }
      }
    }
  }
`

injectGlobal`
  p {
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/footer.js